<template>
  <div>
    <div class="gd-searh__input-wrap">
      <input
        ref="searchInput"
        type="text"
        class="gd-searh__input"
        placeholder="Search by address, suburb..."
      />
      <button class="gd-searh__btn">
        <svg v-if="!loading">
          <use xlink:href="#icon-search-light"></use>
        </svg>
        <div v-else class="loader"></div>
      </button>
      <p v-if="responseMessage" class="gd-searh__not-found">
        {{ responseMessage }}
      </p>
      <div ref="info" class="d-none"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useGetCategory } from "../../composables/getCategory";
import { onMounted } from "vue";

const { searchAuto, searchInput, responseMessage, loading } = useGetCategory();

onMounted(() => {
  searchAuto();
});
</script>
